// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OKSe","expireSoon":"styles_expireSoon__27Ksc"};